/**
 * @file GluestackUIProvider atom — design-token theme context provider.
 * @description Structured atom: re-exports the vendored Gluestack UI provider.
 * This is the only sanctioned import path for app code (RFC §3). The provider
 * seeds the CSS variable cascade and Gluestack mode context used by every atom.
 * @module components/atoms/GluestackUIProvider
 */
export { GluestackUIProvider } from "@/components/ui/gluestack-ui-provider";
